/* Fahrzeug-Modelle search dropdown: client-side filter over DOM-rendered model links. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-gm-root]');
    if (!root) return;

    var form = root.querySelector('[data-gm-search-form]');
    if (!form) return;

    var input = form.querySelector('[data-gm-search-input]');
    var clearBtn = form.querySelector('[data-gm-search-clear]');
    var dropdown = form.querySelector('[data-gm-search-dropdown]');
    var resultsEl = form.querySelector('[data-gm-search-results]');
    var hintEl = form.querySelector('[data-gm-search-hint]');
    if (!input || !clearBtn || !dropdown || !resultsEl || !hintEl) return;

    var items = Array.from(root.querySelectorAll('.gm__pill[data-gm-search], .gm__model-link[data-gm-search]')).map(function (a) {
      return {
        url: a.getAttribute('href'),
        label: (a.textContent || '').trim().replace(/\s+/g, ' '),
        keywords: (a.getAttribute('data-gm-search') || '').toLowerCase(),
        path: (a.getAttribute('data-gm-path') || '').replace(/\s+/g, ' ').trim()
      };
    });

    var activeIndex = -1;

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function openDropdown() {
      dropdown.hidden = false;
      form.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      dropdown.hidden = true;
      form.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function render(q) {
      var query = (q || '').trim().toLowerCase();
      clearBtn.hidden = query.length === 0;
      activeIndex = -1;

      if (!query) {
        resultsEl.innerHTML = '';
        hintEl.hidden = false;
        closeDropdown();
        return;
      }

      var terms = query.split(/\s+/).filter(Boolean);
      var matches = items.filter(function (it) {
        return terms.every(function (t) { return it.keywords.indexOf(t) !== -1; });
      }).slice(0, 12);

      openDropdown();
      hintEl.hidden = true;

      if (matches.length === 0) {
        resultsEl.innerHTML = '<li class="gm-search__result"><div class="gm-search__result-link gm-search__result-link--empty">Keine Treffer für "' + escapeHtml(query) + '"</div></li>';
        return;
      }

      resultsEl.innerHTML = matches.map(function (m, i) {
        return '<li class="gm-search__result" role="option">'
          + '<a class="gm-search__result-link" href="' + escapeHtml(m.url) + '" data-gm-idx="' + i + '">'
          +   '<span class="gm-search__result-title">' + escapeHtml(m.label) + '</span>'
          +   (m.path ? '<span class="gm-search__result-path">' + escapeHtml(m.path) + '</span>' : '')
          + '</a></li>';
      }).join('');
    }

    function setActive(idx) {
      var nodes = resultsEl.querySelectorAll('.gm-search__result-link[data-gm-idx]');
      if (nodes.length === 0) return;
      if (idx < 0) idx = nodes.length - 1;
      if (idx >= nodes.length) idx = 0;
      activeIndex = idx;
      nodes.forEach(function (n) { n.classList.remove('is-active'); });
      nodes[idx].classList.add('is-active');
      nodes[idx].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', function () {
      render(input.value);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim()) render(input.value);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openDropdown();
        setActive(activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIndex - 1);
      } else if (e.key === 'Enter') {
        var nodes = resultsEl.querySelectorAll('.gm-search__result-link[data-gm-idx]');
        var targetIndex = activeIndex >= 0 ? activeIndex : 0;
        if (nodes[targetIndex]) {
          e.preventDefault();
          window.location.href = nodes[targetIndex].getAttribute('href');
        }
      } else if (e.key === 'Escape') {
        closeDropdown();
      }
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      render('');
      input.focus();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closeDropdown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
